var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRatingIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UserRating_Icon_White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3237065,3 C10.8759913,3 11.3237065,3.44771525 11.3237065,4 L11.3231137,4.813 L14.4981137,3 L11.3231137,9.349 L11.3237065,12.5962275 C11.3237065,13.1485122 10.8759913,13.5962275 10.3237065,13.5962275 L2.49811374,13.5962275 C1.94582899,13.5962275 1.49811374,13.1485122 1.49811374,12.5962275 L1.49811374,4 C1.49811374,3.44771525 1.94582899,3 2.49811374,3 L10.3237065,3 Z M9.2251982,6.19586163 L6.99112064,6.92680981 L5.61362164,5.02294505 C5.5746323,4.96907521 5.50534676,4.9464996 5.44209586,4.96705605 C5.37884497,4.9876125 5.33606312,5.04660984 5.33618359,5.113112 L5.34065376,7.46351818 L3.10297603,8.18557417 C3.03969612,8.20601581 2.99681126,8.26492615 2.9968044,8.33142066 C2.99679755,8.39791517 3.03967027,8.45682296 3.10294597,8.47726085 L5.34001508,9.19890207 L5.33548961,11.5501327 C5.33538484,11.6166241 5.3781669,11.6755929 5.44140841,11.6961265 C5.50464993,11.71666 5.57392358,11.6940738 5.6129145,11.6402081 L6.991111,9.73517769 L9.22509875,10.4657445 C9.28830883,10.4864094 9.35763896,10.4639526 9.39673491,10.4101497 C9.43583085,10.3563469 9.43577058,10.2834761 9.3965857,10.2297484 L8.01154178,8.33129902 L9.39666425,6.43177836 C9.43721474,6.37613213 9.43568477,6.30028106 9.39292355,6.24632619 C9.35308583,6.19606849 9.28616355,6.17593318 9.2251982,6.19586163 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#FFFFFF",
    transform: "translate(7.998114, 8.298114) rotate(90.000000) translate(-7.998114, -8.298114) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRatingIconWhite);
export default __webpack_public_path__ + "static/media/UserRating_Icon_White.f65e1284e148eab431e42146007a1b72.svg";
export { ForwardRef as ReactComponent };